import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/landing-page";
import SelectPlan from "./pages/select-plan";
import EVSelectPlan from "./pages/ev-select-plan";
import Auth from "./pages/auth";
import Error from "./pages/error";
import ExistingCustomer from "./pages/existing-customer";
import Env from "./pages/env"
import "./styles/normalize.scss";
import * as oidcApi from "./api/oidcApi";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import CableSubscribed from "./pages/cable-subscribed";
import PurchaseSuccess from "./pages/purchase/purchase-success";
import PurchaseFailed from "./pages/purchase/purchase-failed";
import * as amplitude from '@amplitude/analytics-browser';
import branch from "branch-sdk";
import { jwtDecode } from 'jwt-decode';
import moengage from "@moengage/web-sdk";

function App() {
  moengage.initialize({ app_id: process.env.REACT_APP_MOE_APP_ID, cluster: process.env.REACT_APP_MOE_DATA_CENTER, debug_logs: process.env.REACT_APP_MOE_DEBUG_LOGS });
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    defaultTracking: {
      attribution: true,
      pageViews: false,
      sessions: false,
      formInteractions: false,
      fileDownloads: false
    }
  });
  branch.init(process.env.REACT_APP_BRANCH_KEY);
  branch.getBrowserFingerprintId(function (err, data) {
    console.log("did: " + data);
    amplitude.setDeviceId(data);
    moengage.add_user_attribute("moe_anonymous_id", data);
  });

  const jwt = Cookies.get("UserAuthentication");
  if (jwt) {
    let token = jwtDecode(jwt.replace("ffjwt-", ""));
    if (token?.uid || token?.userID) {
      const uid = token.uid ? token.uid?.toUpperCase() : "SYNACOR-" + token.suserId?.toUpperCase();
      console.log("uid: " + uid);
      amplitude.setUserId(uid);
      moengage.update_unique_user_id(uid);
    }
  }

  if (process.env.REACT_APP_APP_ENV !== 'production') {
    const olt = Cookies.get("olt");
    if (!olt) {
      const state = uuidv4();
      const nonce = uuidv4();
      oidcApi.beginAuth({ state, nonce });
    }
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/select-plan" element={<SelectPlan />} title="Select Plan" />
        <Route path="/ev-select-plan" element={<EVSelectPlan />} />
        <Route path="/error" element={<Error />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/checkenv" element={<Env />} />
        <Route path="/subscribed" element={<ExistingCustomer />} />
        <Route path="/cable-subscribed" element={<CableSubscribed />} />
        <Route path="/purchase/success" element={<PurchaseSuccess />} />
        <Route path="/purchase/failed" element={<PurchaseFailed />} />
      </Routes>
    </div>
  );
}

export default App;
